import {type GuidType} from '../../../values/generic-type-definitions'
import {type Moment} from 'moment'
import {type VesselTag} from '../../../api/vessels/types/vessel-tag'
import {type UpgradeAsset} from '../../../pages/vessel-management/contexts/type/deployment-status-types'

export const FLEET_VIEW_IDENTIFIER = 'fleet-view'
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export type LocationIdType = GuidType | typeof FLEET_VIEW_IDENTIFIER

export interface MetaData {
    imo: string | undefined
    network?: Network
    deployment?: Deployment
    vesselDashboardAgentIds?: string[]
    otSources?: OTSource
}

export interface ReportConfiguration {
    allow: Allow
    target: Target
}

export interface Allow {
    OTDevices: string[] | undefined
    OTCrossings: string[] | undefined
    BusinessDevices: string[] | undefined
    BusinessCrossings: string[] | undefined
    Email: string[] | undefined
    HostLogExceptions: string[] | undefined
    NetworkLogExceptions: string[] | undefined
    USBHosts: string[] | undefined
    USBDevices: string[] | undefined
    AdminLogons: string[] | undefined
    RemoteAccess: string[] | undefined
}

export interface Target {
    EncryptionRatio: string | undefined
    MonitoringCoverage: string | undefined
    MaxOSAge: string | undefined
    MaxScore: number | undefined
}

export interface Network {
    BusinessNetworks: string[] | undefined
    OTNetworks: string[] | undefined
    CrewNetworks: string[] | undefined
    Gateway?: {IP: string | undefined; MAC: string | undefined}
    Other?: string[] | undefined
}

export interface Deployment {
    Incus: {IP: string | undefined; MAC: string | undefined}
    Sensor: {IP: string | undefined; MAC: string | undefined}
}

export interface SourceDestinationOt {
    source: string
    destination: string
}

export interface OTSource {
    syslog: SourceDestinationOt[] | undefined
    nmea: SourceDestinationOt[] | undefined
}

export type locationStatus = 'ACTIVE' | 'ARCHIVED' | 'NOT_READY'

export interface Location {
    location: LocationIdType
    code: string
    description: string
    type?: string
    customerLocationCode: string
    metaData?: MetaData
    reportConfiguration?: ReportConfiguration
    tags?: VesselTag[]
    emailAddress?: string
    vesselDashboard?: boolean
    status: locationStatus
}

export type LocationOperationMerge = {location: LocationIdType} & {
    operating: boolean | null
    upgradeAssets: UpgradeAsset[] | null
    trafficStatus: string[] | null
    vesselDashboard: boolean | null
}

export type LocationMap = Map<LocationIdType, Location>
export interface LocationsReduxState {
    isFetching: boolean
    locations: Location[]
    locationMap: LocationMap
    activeLocation: Location
    lastUpdate: Moment | null
    updatedNetworkDataObject?: Network
    updatedvesselDashboardAgentIds?: GuidType[]
    updatedEmailLocation: string | null | undefined
}

export const DEFAULT_ACTIVE_LOCATION_STATE: Location = {
    location: FLEET_VIEW_IDENTIFIER,
    code: '',
    customerLocationCode: '',
    description: 'Fleet View',
    status: 'NOT_READY',
}

export const DEFAULT_LOCATIONS_STATE: LocationsReduxState = {
    isFetching: true,
    locations: [],
    locationMap: new Map<LocationIdType, Location>(),
    activeLocation: DEFAULT_ACTIVE_LOCATION_STATE,
    lastUpdate: null,
    updatedEmailLocation: undefined,
}

export function isActiveLocation(location: Location): boolean {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    return location && location.location !== FLEET_VIEW_IDENTIFIER
}

const UNKNOWN_VALUE: string = 'Unknown'
export const getLocationDescription = (
    locations: LocationMap,
    location: LocationIdType, // TODO: Fix this the next time the file is edited.
): string => {
    try {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        return locations?.get(location)?.description || UNKNOWN_VALUE
    } catch {
        console.error(`location ${location} does not match a location in the database`)
        return UNKNOWN_VALUE
    }
}

export const getLocationEmail = (
    locations: LocationMap,
    location: LocationIdType,
): string | null => {
    try {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        return locations?.get(location)?.emailAddress ?? null
    } catch {
        console.error(`location ${location} does not match a location in the database`)
        return null
    }
}

export const getLocationCode = (
    locations: LocationMap,
    location: LocationIdType, // TODO: Fix this the next time the file is edited.
): string => {
    try {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        return locations?.get(location)?.code ?? UNKNOWN_VALUE
    } catch {
        console.error(`location ${location} does not match a location in the database`)
        return UNKNOWN_VALUE
    }
}

export const isOnboardDashboard = (locations: LocationMap, location: LocationIdType): boolean => {
    try {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        return locations?.get(location)?.vesselDashboard ?? false
    } catch {
        console.error(`location ${location} does not match a location in the database`)
        return false
    }
}
